import React from 'react';
import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Image, Table, Alert, Spinner, Placeholder, Card } from "react-bootstrap";

import { useEffect, useState, useRef, useMemo } from 'react';
import axios from 'axios';
import Flatpickr from 'react-flatpickr';

import Layout from '../../components/Layout/Layout';
import YearPicker from '../../components/Form/YearPickerInput';
import DropzoneUpload from '../../components/Form/DropzoneUpload';
import ButtonMyinfo from '../../components/Form/ButtonMyinfo';

export default function ApplyLoan() {


    const initialForm = {
        personal: {
            nric: "",
            name: "",
            gender: "",
            race: "",
            nationality: "SINGAPORE CITIZEN",
            residential_status: "CITIZEN",
            dob: "",
            address_line_1: "",
            address_line_2: "",
            address_postal_code: "",
            address_country: "SINGAPORE",
            marital: "",
            email: "",
            mobile_no: "",
            hdb_type: "",
            housing_type: "",
            owner_private: "",
            occupation: "",
            employer_name: "",
            noa_year_1: "",
            noa_income_1: "",
            noa_year_2: "",
            noa_income_2: "",
            cpf_contributions: [],
            vehicles: [],
            // driving_licence: {
            //     qdl_validity: "",
            //     qdl_expiry_date: "",
            //     qdl_classes: [], // array of {class, issue_date}
            //     qdl_class: "",
            //     qdl_issue_date: "",
            // },
        },
        other: {
            chk_own_vehicle: false,
            veh_new_used_category: "",
            veh_new_used: "",
            veh_reg_no: "",
            veh_make: "",
            veh_model: "",
            veh_access_code: "",

            loan_amount: "",
            loan_tenure: "",
            loan_int_rate: "",
            loan_int_rate_desc: "",

            guarantor_name: "",
            guarantor_email: "",
            guarantor_mobile: "",
            guarantor_relationship: "",
            // guarantor_name2: "",
            // guarantor_email2: "",
            // guarantor_mobile2: "",
            // guarantor_relationship2: "",

            dealer_name: "",
            // dealer_person: "",
            dealer_mobile: "",
            dealer_email: "",
            dealer_remarks: "",

            month_income: "",
            salary_comm_above_20: false,
            length_svc: "",
            salesman: "",

        },
        file: { agreement: [] },
        state: "hirer",
        myinfoid: "",
    };


    const location = useLocation();
    const navigate = useNavigate();
    const basePath = process.env.MIX_REACT_BASEPATH || "";
    const iniParams = Object.fromEntries(new URLSearchParams(window.location.search));

    const dropzoneRefAgmt = useRef(null);

    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(true);

    const emptyOptions = [{ value: "", label: "Please select", disabled: false }];
    const [isOwnVehicle, setIsOwnVehicle] = useState(false);
    const [isMyInfo, setIsMyInfo] = useState(false);

    const [form, setForm] = useState(initialForm);
    const [formErrors, setFormErrors] = useState([]);
    const [formServerErrors, setFormServerErrors] = useState([]);
    const [btnSubmit, setBtnSubmit] = useState({ isLoading: false, text: "Submit", loadedText: "Submit" });
    const [disableBtnSubmit, setDisableBtnSubmit] = useState(false);

    const [optionsGender, setOptionsGender] = useState(emptyOptions);
    const [optionsRace, setOptionsRace] = useState(emptyOptions);
    const [optionsNationality, setOptionsNationality] = useState(emptyOptions);
    const [optionsCountry, setOptionsCountry] = useState(emptyOptions);
    const [optionsMarital, setOptionsMarital] = useState(emptyOptions);
    const [optionsHousingType, setOptionsHousingType] = useState(emptyOptions);
    const [optionsHDBType, setOptionsHDBType] = useState(emptyOptions);
    const [optionsResidentialStatus, setOptionsResidentialStatus] = useState(emptyOptions);
    const [optionsOwnerPrivate, setOptionsOwnerPrivate] = useState([
        { value: null, label: "Please select", disabled: false },
        { value: "Y", label: "Y" },
        { value: "N", label: "N" },
    ]);
    const [optionsVehNewUsed, setOptionsVehNewUsed] = useState([
        { value: null, label: "Please select", disabled: false },
        { value: "N", label: "New" },
        { value: "U", label: "Used" },
    ]);
    const [optionsVehNewUsedCat, setOptionsVehNewUsedCat] = useState(emptyOptions);
    const [optionsLoanIntRate, setOptionsLoanIntRate] = useState(emptyOptions);
    const [loanIntRates, setLoanIntRates] = useState({}); // data from API

    const [optionsDrvLicQdlValidity, setOptionsDrvLicQdlValidity] = useState([
        { value: "", label: "Please select", disabled: false },
        { value: "Valid", label: "Valid" },
        { value: "Invalid", label: "Invalid" },
        { value: "Expired", label: "Expired" },
        { value: "Not Holding", label: "Not Holding" },
    ]);
    const [optionsDrvLicQdlClass, setOptionsDrvLicQdlClass] = useState([
        { value: "", label: "Please select", disabled: false },
        { value: "2B", label: "2B" },
        { value: "2A", label: "2A" },
        { value: "2", label: "2" },
        { value: "3A", label: "3A" },
        { value: "3", label: "3" },
        { value: "4A", label: "4A" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
    ]);
    const [optionsGuarRelationships, setOptionsGuarRelationships] = useState([
        { value: "", label: "Please select", disabled: false },
        { value: "Father", label: "Father" },
        { value: "Mother", label: "Mother" },
        { value: "Son", label: "Son" },
        { value: "Daughter", label: "Daughter" },
        { value: "Wife", label: "Wife" },
        { value: "Husband", label: "Husband" },
        { value: "Director", label: "Director" },
    ]);




    const isUsed = (form?.other?.veh_new_used_category || "").trim().split(" ")[0].toLowerCase() === "used";

    const isStateGtor = ["gtor1", "gtor2", "gtor3"].includes((form?.state || "").trim().toLowerCase());


    const setIn = (obj, path, value) => {
        const keys = Array.isArray(path) ? path : String(path).split(".");
        const draft = { ...obj };
        let cur = draft;
        keys.forEach((k, idx) => {
            if (idx === keys.length - 1) {
                cur[k] = value;
            } else {
                cur[k] = { ...(cur[k] || {}) };
                cur = cur[k];
            }
        });
        return draft;
    };

    const handleField = (path) => (e) => {

        // Normalize value + label from different widgets
        const norm = (() => {
            if (e?.target) {
                const value =
                    e.target.type === "file"
                    ? e.target.files?.[0] ?? null
                    : e.target.type === "checkbox"
                        ? e.target.checked
                        : e.target.value;

                const label =
                    e.target.tagName === "SELECT"
                    ? e.target.selectedOptions?.[0]?.text ?? ""
                    : "";

                return { value, label };
            } else if (e && typeof e === "object" && "value" in e && "label" in e) {
                // react-select style
                return { value: e.value, label: e.label };
            }
            // Fallback (e.g., direct value)
            return { value: e, label: "" };
        })();

        const v = norm.value;
        const lbl = norm.label;




        setForm((prev) => {
            // first, set the field that changed
            let next = setIn(prev, path, v);

            // set other fields conditionally
            if (path === "personal.nationality") {
                const isCitizen = typeof v === "string" && v.trim().toUpperCase() === "SINGAPORE CITIZEN";
                next = setIn(next, "personal.residential_status", isCitizen ? "CITIZEN" : "");
            } else if (path === "other.loan_int_rate") {
                next = setIn(next, "other.loan_int_rate_desc", lbl);
            }

            return next;
        });
    };

    const renderOptions = (opts) => opts.map((o, idx) => (
        <option key={`${o.value}-${idx}`} value={o.value} disabled={o.disabled}>{o.label}</option>
    ));

    const onChangeVehNewUsedCategory = (value) => {

        const rates = loanIntRates[value] || [];

        setOptionsLoanIntRate([
            { value: "", label: "Please select" },
            ...rates.map((value, label) => ({
                value: value.int_rate,
                label: `${value.int_rate}% | ${value.description}`,
            })),
        ]);

        setForm((prev) => {
            return setIn(prev, 'other.veh_new_used_category', value);
        });


        let vehNewUsed = "";
        const firstWord = value.trim().split(" ")[0].toLowerCase();
        if (firstWord === "used") {
            vehNewUsed = "U";
        } else if (firstWord === "new") {
            vehNewUsed = "N";
        }
        setForm((prev) => setIn(prev, 'other.veh_new_used', vehNewUsed));
    };

    const onChangeIsOwnVehicle = (value) => {
        setIsOwnVehicle(value);
        setForm((prev) => setIn(prev, 'other.chk_own_vehicle', value));
    };




    // Effect only once on mount 
    useEffect(() => {

        // document.title = "Apply Loan";

        let mounted = true;

        (async () => {
            try {

                if (!mounted) return;


                // myinfo submission
                ///////////////////////////////////////////////////////////////////
                if (iniParams?.s) {

                    const { data } = await axios.post(`${basePath}/retrieve-myinfo`, iniParams);

                    if (data?.status === "success") {
                        // alert(data?.message || "retrieve successfully");
                    }

                    // Detect MyInfo mode (if server returned a flag like original code)
                    setIsMyInfo(true);

                    const formData = data?.form ?? {};

                    setForm((prev) => ({
                        ...prev,
                        ...formData, // merges id, state, etc.
                        personal: {
                            ...prev.personal,
                            ...(formData.personal || {}) // merges nested personal
                        },
                    }));


                    if (data?.codes) {
                        const o = data.codes;

                        if (o?.int_rate_category) {
                            const entries = o.int_rate_category && typeof o.int_rate_category === "object" ? Object.entries(o.int_rate_category) : [];
                            setOptionsVehNewUsedCat([
                                { value: "", label: "Please select" },
                                ...entries.map(([value, label]) => ({ value: value, label: value })),
                            ]);

                            setLoanIntRates(o.int_rate_category);
                        }
                    }

                    return;
                }


                // manual submission
                ///////////////////////////////////////////////////////////////////
                const { data } = await axios.get(`${basePath}/myinfo/application`, { params: iniParams });


                // Map arrays to {value,label}
                const mapOpt = (arr) => {
                    const entries = arr && typeof arr === "object" ? Object.entries(arr) : [];

                    return [
                        { value: "", label: "Please select" },
                        ...entries.map(([value, label]) => ({ value: label, label: label })),
                    ];
                };

                if (data?.codes) {
                    const o = data.codes;

                    if (o.sex) setOptionsGender(mapOpt(o.sex));
                    if (o.race) setOptionsRace(mapOpt(o.race));
                    if (o.nationality) setOptionsNationality(mapOpt(o.nationality));
                    if (o.country) setOptionsCountry(mapOpt(o.country));
                    if (o.marital) setOptionsMarital(mapOpt(o.marital));
                    if (o.housing_type) setOptionsHousingType(mapOpt(o.housing_type));
                    if (o.hdb_type) setOptionsHDBType(mapOpt(o.hdb_type));
                    if (o.residential) setOptionsResidentialStatus(mapOpt(o.residential));

                    if (o?.int_rate_category) {
                        const entries = o.int_rate_category && typeof o.int_rate_category === "object" ? Object.entries(o.int_rate_category) : [];
                        setOptionsVehNewUsedCat([
                            { value: "", label: "Please select" },
                            ...entries.map(([value, label]) => ({ value: value, label: value })),
                        ]);

                        setLoanIntRates(o.int_rate_category);
                    }
                }

            }
            catch (err) {
                // console.error(err);
                navigate("/landing/error", { state: { message: err.response?.data?.message || err.message } });
            }
            finally {
                if (mounted) setLoading(false);
            }

        })();
        return () => { mounted = false; };
    }, []);


    // Effect when specific values change
    useEffect(() => {

        // set sessionStorage state
        ///////////////////////////////////////////////////////////////////
        const queryParams = new URLSearchParams(location.search);

        let paramState = queryParams.get("state");
        let paramMyinfoId = queryParams.get("myinfoid");

        if (paramState && paramMyinfoId) {
            sessionStorage.setItem("weberp_form_state", paramState);
            sessionStorage.setItem("weberp_form_myinfoid", paramMyinfoId);
        }

        let state = (sessionStorage.getItem("weberp_form_state"));
        let myinfoId = (sessionStorage.getItem("weberp_form_myinfoid"));


        if (["gtor1", "gtor2", "gtor3"].includes((state || "").trim().toLowerCase())) {
            setForm((prev) => setIn(prev, 'state', state));
            setForm((prev) => setIn(prev, 'myinfoid', myinfoId));
        }

    }, [location]);



    const buildFormData = (formData, data, parentKey) => {
        if (data && typeof data === "object" && !(data instanceof File) && !(data instanceof Date)) {
            Object.keys(data).forEach((key) => {
                const value = data[key];
                const newKey = parentKey ? `${parentKey}[${key}]` : key;
                buildFormData(formData, value, newKey);
            });
        } else {
            formData.append(parentKey, data ?? "");
        }
    };


    const validatePass = () => {

        const errs = [];

        if (form.state == "hirer") {
            if (!form.personal.nric) errs.push("NRIC is required.");
            if (!form.personal.name) errs.push("Name is required.");
            if (!form.personal.dob) errs.push("DOB is required.");
            if (!form.personal.email) errs.push("Email is required.");
            if (!form.personal.mobile_no) errs.push("Mobile No. is required.");

            if (!form.other.month_income) errs.push("Month Income is required.");
            if (!form.other.length_svc) errs.push("Length of Service is required.");

            // if (!form.other.veh_new_used_category) errs.push("Vehicle New / Used is required.");
            if (!form.other.veh_new_used_category) errs.push("Intended Usage is required.");

            if (!form.other.loan_amount) errs.push("Loan Amount is required.");
            if (!form.other.loan_tenure) errs.push("Loan Tenure is required.");
            if (Number(form.other.loan_tenure) > 84) errs.push("Maximum of Loan Tenure is 84 months.");
            if (!form.other.loan_int_rate) errs.push("Loan Interest Rate is required.");
        }
        else {
            if (!form.personal.nric) errs.push("NRIC is required.");
            if (!form.personal.name) errs.push("Name is required.");
            if (!form.personal.dob) errs.push("DOB is required.");
            if (!form.personal.email) errs.push("Email is required.");
            if (!form.personal.mobile_no) errs.push("Mobile No. is required.");
        }
        


        setFormErrors(errs);
        return errs.length === 0;
    };


    const handleSubmitBs = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validatePass()) return;

        // Dropzone: 1. Detect uploaded files
        const dzAgmtFiles = dropzoneRefAgmt.current?.getFiles?.() || [];
        // if (dzAgmtFiles.length === 0) {
        //     alert("Please upload at least one document.");
        //     return;
        // }


        setBtnSubmit((s) => ({ ...s, isLoading: true, text: "Submitting..." }));
        setDisableBtnSubmit(true);
        setFormErrors([]);
        setFormServerErrors([]);

        try {
            const fd = new FormData();

            // buildFormData(fd, form, "form");
            buildFormData(fd, form, "");

            // Dropzone: 2. Append all files
            dzAgmtFiles.forEach(f => fd.append('file[agreement][]', f));


            const { data } = await axios.post(`${basePath}/myinfo/application`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (data?.status === "success") {
                // alert(data?.message || "Submitted successfully");
                // navigate("/landing/success", { state: { message: `Form submission successful.\nRef No: ${data.refNo}` } });
                navigate("/landing/success", { state: { message: data?.message || "Submitted successfully" } });
            }
            else {
                let errorMsg = data?.message || "Submitted failed";
                setFormServerErrors([errorMsg]);

            }
        } catch (err) {
            if ([422].includes(err?.response?.status) && err.response?.data?.message) {
                // Laravel validation errors
                const messages = Object.values(err.response.data.message).join("\n");
                setFormServerErrors(messages.split("\n"));
            }
            else if ([400].includes(err?.response?.status) && err.response?.data?.message) {
                const messages = err.response.data.message;
                setFormServerErrors(messages.split("|@@|"));
            }
            else {
                // console.error(err);
                navigate("/landing/error", { state: { message: err.response?.data?.message || err.message } });


            }
        } finally {
            setBtnSubmit((s) => ({ ...s, isLoading: false, text: s.loadedText }));
            setDisableBtnSubmit(false);
        }
    };


    if (loading) return (
        <Layout>
            <div className="text-center mb-5" style={{ height: "500px" }}>
                <Placeholder animation="glow">
                    <Placeholder xs={6} sm={3} style={{ height: "80px" }} />

                    <Placeholder xs={12} style={{ marginTop: "50px", height: "120px" }} />

                    <Placeholder xs={12} style={{ marginTop: "30px", height: "320px" }} />
                </Placeholder>
            </div>
        </Layout>
    );


    return (
        <>
            <Layout>

                <div className="page_main_title">
                    <h1>Apply Loan {isStateGtor && <span>(Guarantor)</span>}</h1>
                    <p>Where Ownership Begins</p>
                </div>

                <div className="contact_us_main">
                    {/* <Form noValidate validated={validated} onSubmit={handleSubmit}> */}
                    <Form noValidate onSubmit={handleSubmit}>

                        {/* BOX: Myinfo */}
                        <div className="box">
                            <Row>
                                <Col md={12}>
                                    <div className="loan_myinfo_wrap text-center py-2">
                                        <div className="img_icon">
                                            <Image src="../assets/image/singpass_logo.svg" alt="Singpass Logo" fluid />
                                        </div>
                                        <div className="text">
                                            <p>Log in with your Singpass to use relevant Myinfo data to pre-fill the form for a hassle-free application and supporting documents are not required.</p>
                                        </div>
                                        <ButtonMyinfo />
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        {/* BOX: Personal Information */}
                        <div className="box">
                            <Row>
                                <Col xs={12}>
                                    <div className="box_title_wrap">
                                        <h2>Personal Information</h2>
                                    </div>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>NRIC / Passport / FIN <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control type="text" value={form.personal.nric} placeholder="Enter ID" onChange={handleField("personal.nric")} readOnly={isMyInfo} required />
                                                <Form.Control.Feedback type="invalid">Required field</Form.Control.Feedback>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Name <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control type="text" value={form.personal.name} placeholder="Enter Name" onChange={handleField("personal.name")} readOnly={isMyInfo} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Gender</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.gender} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.gender} onChange={handleField("personal.gender")}>{renderOptions(optionsGender)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Race</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.race} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.race} onChange={handleField("personal.race")}>{renderOptions(optionsRace)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Nationality</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.nationality} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.nationality} onChange={handleField("personal.nationality")}>{renderOptions(optionsNationality)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Date of Birth <span style={{ color: "red" }}>*</span></Form.Label>
                                                <div className="form_group_icon">
                                                    <div className="icon">
                                                        <i className="fi fi-rr-calendar" />
                                                    </div>
                                                    {isMyInfo ? (
                                                        <Form.Control value={form.personal.dob} readOnly />
                                                    ) : (
                                                        <Flatpickr className="form-control" options={{ dateFormat: 'Y-m-d' }} placeholder="Select Date" value={form.personal.dob} onChange={(selectedDates, dateStr) => handleField("personal.dob")(dateStr)} />
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                        
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Marital Status</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.marital} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.marital} onChange={handleField("personal.marital")}>{renderOptions(optionsMarital)}</Form.Select>
                                                )}

                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Email Address <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control type="email" placeholder="Enter Email address" value={form.personal.email} onChange={handleField("personal.email")} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Mobile No. <span style={{ color: "red" }}>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Enter Mobile no." value={form.personal.mobile_no} onChange={handleField("personal.mobile_no")} />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Address Line 1</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Address line 1" value={form.personal.address_line_1} onChange={handleField("personal.address_line_1")} readOnly={isMyInfo} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Address Line 2</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Address line 2" value={form.personal.address_line_2} onChange={handleField("personal.address_line_2")} readOnly={isMyInfo} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <Row>
                                                <Col xs={6}>
                                                    <div className="form_main">
                                                        <Form.Label>Country</Form.Label>
                                                        {isMyInfo ? (
                                                            <Form.Control value={form.personal.address_country} readOnly />
                                                        ) : (
                                                            <Form.Select value={form.personal.address_country} onChange={handleField("personal.address_country")}>{renderOptions(optionsCountry)}</Form.Select>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col xs={6}>
                                                    <div className="form_main">
                                                        <Form.Label>Postal Code</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Postal code" value={form.personal.address_postal_code} onChange={handleField("personal.address_postal_code")} readOnly={isMyInfo} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Residential Status</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.residential_status} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.residential_status} onChange={handleField("personal.residential_status")}>{renderOptions(optionsResidentialStatus)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Type of HDB</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.hdb_type} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.hdb_type} onChange={handleField("personal.hdb_type")}>{renderOptions(optionsHDBType)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Type of Housing</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.housing_type} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.housing_type} onChange={handleField("personal.housing_type")}>{renderOptions(optionsHousingType)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Ownership of Private Residential</Form.Label>
                                                {isMyInfo ? (
                                                    <Form.Control value={form.personal.owner_private} readOnly />
                                                ) : (
                                                    <Form.Select value={form.personal.owner_private} onChange={handleField("personal.owner_private")}>{renderOptions(optionsOwnerPrivate)}</Form.Select>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Occupation</Form.Label>
                                                <Form.Control type="text" value={form.personal.occupation} onChange={handleField("personal.occupation")} placeholder={isMyInfo ? "" : "Enter Occupation"} readOnly={isMyInfo} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form_main">
                                                <Form.Label>Employer Name</Form.Label>
                                                <Form.Control type="text" value={form.personal.employer_name} onChange={handleField("personal.employer_name")} placeholder={isMyInfo ? "" : "Enter Employer name"} readOnly={isMyInfo} />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <div className="form_main pb-0">
                                                <Form.Label>Notice of Assessment (Last 2 Years)</Form.Label>
                                            </div>

                                            <div key="1" className="inner_box inner_box_input">
                                                <div className="label">
                                                    <label>Year</label>
                                                </div>
                                                <div className="form_main">
                                                    {isMyInfo ? (
                                                        <Form.Control value={form.personal.noa_year_1} readOnly />
                                                    ) : (
                                                        <YearPicker placeholder={`eg. 2024`} value={form.personal.noa_year_1} onChange={(val) => handleField("personal.noa_year_1")(val)} />
                                                    )}
                                                </div>
                                                <div className="divider"></div>
                                                <div className="form_main">
                                                    <input type="text" className="form-control" placeholder="Amount" value={form.personal.noa_income_1} onChange={handleField("personal.noa_income_1")} readOnly={isMyInfo} />
                                                </div>
                                            </div>

                                            <div key="2" className="inner_box inner_box_input">
                                                <div className="label">
                                                    <label>Year</label>
                                                </div>
                                                <div className="form_main">
                                                    {isMyInfo ? (
                                                        <Form.Control value={form.personal.noa_year_2} readOnly />
                                                    ) : (
                                                        <YearPicker placeholder={`eg. 2024`} value={form.personal.noa_year_2} onChange={(val) => handleField("personal.noa_year_2")(val)} />
                                                    )}
                                                </div>
                                                <div className="divider"></div>
                                                <div className="form_main">
                                                    <input type="text" className="form-control" placeholder="Amount" value={form.personal.noa_income_2} onChange={handleField("personal.noa_income_2")} readOnly={isMyInfo} />
                                                </div>
                                            </div>
                                        </Col>
                                        {!isStateGtor && (
                                            <Col md={4}>
                                                <div className="form_main">
                                                    <Form.Label>Monthly Income Amount <span style={{ color: "red" }}>*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Amount" onChange={handleField("other.month_income")} />
                                                    <div style={{ margin: "8px 5px" }}>
                                                        <Form.Check id="checkbox_comm">
                                                            <Form.Check.Input type="checkbox" onChange={handleField("other.salary_comm_above_20")}/>
                                                            <Form.Check.Label style={{ fontSize: "14px" }}>Salary with Commission above 20%</Form.Check.Label>
                                                        </Form.Check>
                                                    </div>
                                                </div>
                                            </Col>
                                        )}
                                        {!isStateGtor && (
                                            <Col md={4}>
                                                <div className="form_main">
                                                    <Form.Label>Length of Service <span style={{ color: "red" }}>*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Enter Year" onChange={handleField("other.length_svc")} />
                                                </div>
                                            </Col>
                                        )}
                                    </Row>

                                </Col>
                            </Row>
                        </div>

                        {form.personal.cpf_contributions.length > 0 && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>CPF Contributions History</h2>
                                        </div>
                                    </Col>
                                    <Col md={8}>
                                        <Table striped hover className="form_table">
                                            <thead>
                                                <tr>
                                                    {Object.keys(form.personal.cpf_contributions[0]).map((key) => (
                                                        <th key={key} style={{ textTransform: "capitalize" }}>{key}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {form.personal.cpf_contributions.map((item, idx) => (
                                                    <tr key={idx}>
                                                        {Object.values(item).map((val, i) => (
                                                            <td key={i}>{val}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <Col md={4}></Col>

                                </Row>
                            </div>
                        )}


                        {/* BOX: Driving License */}
                        {form.personal.driving_licence?.length > 0 && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>Driving License</h2>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>QDL Validity</Form.Label>
                                            {isMyInfo ? (
                                                <Form.Control type="text" value={form.personal.driving_licence.qdl_validity} readOnly />
                                            ) : (
                                                <Form.Select value={form.personal.driving_licence.qdl_validity} onChange={handleField("personal.driving_licence.qdl_validity")}>{renderOptions(optionsDrvLicQdlValidity)}</Form.Select>
                                            )}
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>QDL Expiry Date</Form.Label>
                                            {isMyInfo ? (
                                                <Form.Control value={form.personal.driving_licence.qdl_expiry_date} readOnly />
                                            ) : (
                                                <Flatpickr className="form-control" options={{ dateFormat: 'Y-m-d' }} placeholder="Select Date" value={form.personal.driving_licence.qdl_expiry_date} onChange={(selectedDates, dateStr) => handleField("personal.driving_licence.qdl_expiry_date")(dateStr)} />
                                            )}
                                        </Form.Group>
                                    </Col>

                                    <Col md={8}>
                                        {isMyInfo ? (
                                            <Form.Group className="mb-3">
                                                <Form.Label>QDL Classes</Form.Label>
                                                {!form.personal.driving_licence.qdl_classes?.length ? (
                                                    <div>No classes found</div>
                                                ) : (
                                                    <Table bordered size="sm" class="form_table">
                                                        <thead>
                                                            <tr>
                                                                <th>Class</th>
                                                                <th>Issue Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {form.personal.driving_licence.qdl_classes.map((c, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{c.class}</td>
                                                                    <td>{c.issue_date}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                )}
                                            </Form.Group>
                                        ) : (
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>QDL Class</Form.Label>
                                                        <Form.Select value={form.personal.driving_licence.qdl_class} onChange={handleField("personal.driving_licence.qdl_class")}>{renderOptions(optionsDrvLicQdlClass)}</Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>QDL Issue Date</Form.Label>
                                                        {isMyInfo ? (
                                                            <Form.Control value={form.personal.driving_licence.qdl_issue_date} readOnly />
                                                        ) : (
                                                            <Flatpickr className="form-control" options={{ dateFormat: 'Y-m-d' }} placeholder="Select Date" value={form.personal.driving_licence.qdl_issue_date} onChange={(selectedDates, dateStr) => handleField("personal.driving_licence.qdl_issue_date")(dateStr)} />
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        )}


                        {/* BOX: About Your Vehicle */}
                        {!isStateGtor && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>About Your Vehicle</h2>
                                        </div>

                                        {/* <Form.Check type="switch" className="switch-sm" label="Is this loan for your own vehicle?" checked={isOwnVehicle} onChange={(e) => setIsOwnVehicle(e.target.checked)} /> */}
                                        <Form.Check type="switch" className="switch-sm" label="Is this loan for your own vehicle?" checked={isOwnVehicle} onChange={(e) => onChangeIsOwnVehicle(e.target.checked)} />

                                        <Row>
                                            <Col md={4}>
                                                <div className="form_main">
                                                    {/* <Form.Label>New / Used <span style={{ color: "red" }}>*</span></Form.Label> */}
                                                    <Form.Label>Intended Usage <span style={{ color: "red" }}>*</span></Form.Label>
                                                    <Form.Select value={form.other.veh_new_used_category} onChange={(e) => onChangeVehNewUsedCategory(e.target.value)}>{renderOptions(optionsVehNewUsedCat)}</Form.Select>
                                                </div>
                                            </Col>

                                            {!isUsed && (
                                                <>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Make</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Make" onChange={handleField("other.veh_make")} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Model</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Model" onChange={handleField("other.veh_model")} />
                                                        </div>
                                                    </Col>
                                                </>
                                            )}

                                            {isUsed && (
                                                <>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Reg No.</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Reg number" onChange={handleField("other.veh_reg_no")} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>LTA Access Code</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter LTA Access code" onChange={handleField("other.veh_access_code")} />
                                                        </div>
                                                    </Col>
                                                </>
                                            )}

                                        </Row>

                                        {/* Dealer vehicle (when NOT own vehicle) */}
                                        {!isOwnVehicle && (
                                            <div className="dealer_vehicle">

                                                <Row>
                                                    <Col xs={12}>
                                                        <div className="box_inner_sub_title">
                                                            <p>Fill in your Dealer Info</p>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Dealer Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Name" onChange={handleField("other.dealer_name")} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Dealer Mobile</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Mobile number" onChange={handleField("other.dealer_mobile")} />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Dealer Email</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Email" onChange={handleField("other.dealer_email")} />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md={4}>
                                                        <div className="form_main">
                                                            <Form.Label>Dealer Remarks</Form.Label>
                                                            <Form.Control as="textarea" className="custom_textarea_height" placeholder="Enter Remarks" onChange={handleField("other.dealer_remarks")} />
                                                        </div>
                                                    </Col>
                                                    
                                                </Row>
                                            </div>
                                        )}

                                        {/* Own vehicle */}
                                        {isOwnVehicle && (
                                            <div className="own_vehicle">

                                            </div>
                                        )}

                                        <Col md={12}>
                                            <div className="form_main">
                                                <Form.Label>Upload Document (e.g. NRIC, VSA and Income Proof)</Form.Label>
                                                <DropzoneUpload ref={dropzoneRefAgmt} />
                                            </div>
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                        )}


                        {/* BOX: About Your Loan */}
                        {!isStateGtor && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>About Your Loan</h2>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Loan Amount <span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Enter Amount" onChange={handleField("other.loan_amount")} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Loan Tenure (Months) <span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Enter Tenure" onChange={handleField("other.loan_tenure")} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Interest Rate <span style={{ color: "red" }}>*</span></Form.Label>
                                            <Form.Select value={form.other.loan_int_rate} onChange={handleField("other.loan_int_rate")}>{renderOptions(optionsLoanIntRate)}</Form.Select>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}


                        {/* BOX: Guarantor Info */}
                        {!isStateGtor && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>Guarantor Info</h2>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Guarantor name" onChange={handleField("other.guarantor_name")} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Email" onChange={handleField("other.guarantor_email")} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Mobile</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Mobile number" onChange={handleField("other.guarantor_mobile")} />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Relationship</Form.Label>
                                            <Form.Select value={form.other.guarantor_relationship} onChange={handleField("other.guarantor_relationship")}>{renderOptions(optionsGuarRelationships)}</Form.Select>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}


                        {/* BOX: Salesman */}
                        {!isStateGtor && (
                            <div className="box">
                                <Row>
                                    <Col xs={12}>
                                        <div className="box_title_wrap">
                                            <h2>Salesman</h2>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <div className="form_main">
                                            <Form.Label>Salesman Code (If Any)</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Code" onChange={handleField("other.salesman")} />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Submit */}
                        <Row>
                            <Col xs={12} className="text-center">
                                <Button type="submit" size="lg" variant="" className="btn_primary" disabled={disableBtnSubmit || btnSubmit.isLoading}>
                                    {btnSubmit.isLoading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" /> Submitting...
                                        </>
                                    ) : (
                                        btnSubmit.text
                                    )}
                                </Button>

                                {formServerErrors?.length > 0 && (
                                    <Alert key='danger' variant='danger' className='mt-3'>
                                        {formServerErrors.map((e, i) => (
                                            <div key={i}>{e}</div>
                                        ))}
                                    </Alert>
                                )}

                                {formErrors?.length > 0 && (
                                    <Alert key='danger' variant='danger' className='mt-3'>
                                        {formErrors.map((e, i) => (
                                            <div key={i}>{e}</div>
                                        ))}
                                    </Alert>
                                )}

                            </Col>
                        </Row>

                    </Form>
                </div>


            </Layout >
        </>
    );
}